export const SOFTWARE_TABS = ['marketing', 'sales', 'customer-service', 'operations', 'general-overview'];
export const SoftwareRecommendationsViewMoreListMap = {
  marketing: 'MARKETING_HUB_TOOLS',
  sales: 'SALES_HUB_TOOLS',
  'customer-service': 'SERVICE_HUB_TOOLS',
  operations: null,
  'general-overview': ['MARKETING_HUB_TOOLS', 'SERVICE_HUB_TOOLS', 'SALES_HUB_TOOLS']
};
export const FEATURED_BY_FIELD_PROD = {
  marketing: [{
    type: 'TRACK',
    id: 9219692
  },
  // HubSpot Marketing Hub Software
  {
    type: 'TRACK',
    id: 9023279
  }, {
    type: 'TRACK',
    id: 9028217
  }, {
    type: 'TRACK',
    id: 9090828
  }],
  sales: [{
    type: 'TRACK',
    id: 8984877
  }, {
    type: 'TRACK',
    id: 9147486
  },
  // HubSpot Sales Hub Software
  {
    type: 'LESSON',
    id: 8887719
  }, {
    type: 'TRACK',
    id: 9045581
  }, {
    type: 'LESSON',
    id: 9304866
  }],
  'customer-service': [{
    type: 'TRACK',
    id: 9149328
  }, {
    type: 'TRACK',
    id: 9148739
  }, {
    type: 'TRACK',
    id: 9181275
  }, {
    type: 'TRACK',
    id: 9103186
  }, {
    type: 'LESSON',
    id: 9320773
  }],
  operations: [{
    type: 'LESSON',
    id: 9081152
  }, {
    type: 'LESSON',
    id: 8784918
  }, {
    type: 'LESSON',
    id: 8784913
  },
  // Introduction to Operations Hub
  {
    type: 'LESSON',
    id: 9293106
  }, {
    type: 'LESSON',
    id: 9306152
  }],
  'general-overview': [{
    type: 'TRACK',
    id: 8984877
  },
  // Set Up Your HubSpot CRM for Growth
  {
    type: 'TRACK',
    id: 9023279
  },
  // Using HubSpot's Free Marketing Tools
  {
    type: 'LESSON',
    id: 8887719
  },
  // Sales Hub Starter Onboarding
  {
    type: 'TRACK',
    id: 9147486
  },
  // HubSpot Sales Hub Software
  {
    type: 'TRACK',
    id: 9219692
  } // HubSpot Marketing Hub Software,
  ]
};
export const FEATURED_GENERIC_PROD = FEATURED_BY_FIELD_PROD['general-overview'];
export const FEATURED_BY_LANGUAGE_PROD = {
  fr: [{
    type: 'LESSON',
    id: 9352365
  }, {
    type: 'LESSON',
    id: 9352359
  }, {
    type: 'LESSON',
    id: 9305465
  }, {
    type: 'LESSON',
    id: 9306154
  }, {
    type: 'LESSON',
    id: 9352371
  }, {
    type: 'LESSON',
    id: 9305477
  }],
  es: [{
    type: 'LESSON',
    id: 9352364
  }, {
    type: 'LESSON',
    id: 9352358
  }, {
    type: 'LESSON',
    id: 9305464
  }, {
    type: 'LESSON',
    id: 9306153
  }, {
    type: 'LESSON',
    id: 9352370
  }, {
    type: 'LESSON',
    id: 9305476
  }],
  de: [{
    type: 'LESSON',
    id: 9352362
  }, {
    type: 'LESSON',
    id: 9352356
  }, {
    type: 'LESSON',
    id: 9305462
  }, {
    type: 'LESSON',
    id: 9306151
  }, {
    type: 'LESSON',
    id: 9352368
  }, {
    type: 'LESSON',
    id: 9305474
  }],
  ja: [{
    type: 'LESSON',
    id: 9352366
  }, {
    type: 'LESSON',
    id: 9352360
  }, {
    type: 'LESSON',
    id: 9305466
  }, {
    type: 'LESSON',
    id: 9306155
  }, {
    type: 'LESSON',
    id: 314
  }, {
    type: 'LESSON',
    id: 9305478
  }],
  pt: [{
    type: 'LESSON',
    id: 9352367
  }, {
    type: 'LESSON',
    id: 9352361
  }, {
    type: 'LESSON',
    id: 9305467
  }, {
    type: 'LESSON',
    id: 9306156
  }, {
    type: 'LESSON',
    id: 9352373
  }, {
    type: 'LESSON',
    id: 9306162
  }]
};
export const FEATURED_GENERIC_QA = [{
  type: 'LESSON',
  id: 17693051
}, {
  type: 'LESSON',
  id: 17693061
}, {
  type: 'LESSON',
  id: 17690804
}, {
  type: 'TRACK',
  id: 1099107
}, {
  type: 'TRACK',
  id: 1099191
}];
export const FEATURED_BY_LANGUAGE_QA = [{
  type: 'TRACK',
  id: 1099124
}, {
  type: 'LESSON',
  id: 17690819
}, {
  type: 'LESSON',
  id: 17690732
}, {
  type: 'LESSON',
  id: 17687052
}, {
  type: 'TRACK',
  id: 1099084
}];